import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=17df4795&"
import script from "./EditModal.vue?vue&type=script&lang=js&"
export * from "./EditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17df4795')) {
      api.createRecord('17df4795', component.options)
    } else {
      api.reload('17df4795', component.options)
    }
    module.hot.accept("./EditModal.vue?vue&type=template&id=17df4795&", function () {
      api.rerender('17df4795', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffCalendar/EditModal.vue"
export default component.exports